"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var undefinedUrl;

var NavBarCollapse =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(NavBarCollapse, _PureComponent);

  function NavBarCollapse() {
    _classCallCheck(this, NavBarCollapse);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavBarCollapse).apply(this, arguments));
  }

  _createClass(NavBarCollapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$list = _this$props.list,
          propsList = _this$props$list === void 0 ? [] : _this$props$list,
          searchValue = _this$props.searchValue,
          onSearchChange = _this$props.onSearchChange,
          open = _this$props.open,
          LinkComponent = _this$props.LinkComponent,
          propsValue = _this$props.value;
      var className = (0, _classnames["default"])('spaui-topnav-collapse', {
        'is-collapse': !open
      });
      var list = [];
      var haveLeft = false;
      var haveRight = false;

      if (propsList.length < 2 && propsList.length > 0) {
        propsList.map(function (item) {
          if (item.placement === 'left') {
            haveLeft = true;
            list.push(item);
          } else if (item.placement === 'right') {
            haveRight = true;
            list.push(item);
          }

          return item;
        });

        if (haveRight && !haveLeft) {
          list.unshift({
            placement: 'left'
          });
        }
      } else {
        list = propsList;
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: className,
        needTitle: false
      }), list.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var _item$placement = item.placement,
            placement = _item$placement === void 0 ? '' : _item$placement,
            _item$value = item.value,
            value = _item$value === void 0 ? '' : _item$value,
            _item$data = item.data,
            data = _item$data === void 0 ? [] : _item$data;
        return _react["default"].createElement("ul", {
          className: (0, _classnames["default"])('navs spaui-topnav-nav', item.className || '', {
            'spaui-topnav-right': placement === 'right'
          }),
          key: index
        }, data.map(function () {
          var dataItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var dataIndex = arguments.length > 1 ? arguments[1] : undefined;
          var _dataItem$data = dataItem.data,
              subData = _dataItem$data === void 0 ? [] : _dataItem$data,
              _dataItem$type = dataItem.type,
              type = _dataItem$type === void 0 ? '' : _dataItem$type,
              _dataItem$url = dataItem.url,
              url = _dataItem$url === void 0 ? '' : _dataItem$url,
              target = dataItem.target,
              _dataItem$key = dataItem.key,
              key = _dataItem$key === void 0 ? '' : _dataItem$key,
              _dataItem$label = dataItem.label,
              label = _dataItem$label === void 0 ? '' : _dataItem$label,
              _dataItem$disabled = dataItem.disabled,
              disabled = _dataItem$disabled === void 0 ? false : _dataItem$disabled,
              _dataItem$className = dataItem.className,
              dataItemClassName = _dataItem$className === void 0 ? '' : _dataItem$className;
          var subDataList = [];
          var result = null;
          var liClassName = (0, _classnames["default"])('nav-item', dataItemClassName);
          var itemClassName = 'nav-link';
          var TheComponent = null;

          if (type === 'component' && dataItem.component) {
            TheComponent = dataItem.component;
            return _react["default"].createElement(TheComponent, _extends({}, dataItem, {
              key: dataItem.type + dataIndex,
              component: "",
              className: liClassName,
              value: value,
              rootValue: propsValue
            }));
          }

          if (key && type !== 'search' && type !== 'userinfo') {
            liClassName = (0, _classnames["default"])(liClassName, {
              active: key === value || key === propsValue,
              disabled: disabled,
              'spaui-topnav-drop': subData.length > 0
            });

            if (subData.length > 0) {
              itemClassName += ' spaui-topnav-toggle';
              subData.map(function (subDataItem) {
                subDataList.push(subDataItem.key);
                return subDataItem;
              });

              if ((0, _spauiUtils.indexOf)(subDataList, value) > -1 || (0, _spauiUtils.indexOf)(subDataList, propsValue) > -1) {
                liClassName += ' active';
              }

              result = _react["default"].createElement("li", {
                role: "presentation",
                className: liClassName,
                key: dataIndex
              }, _react["default"].createElement(LinkComponent, _extends({
                name: key,
                role: "button",
                className: itemClassName,
                href: url || undefinedUrl,
                target: target,
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, (0, _index.getSupportEventMap)(dataItem), (0, _index.getDataSet)(dataItem)), label), _react["default"].createElement("div", {
                className: "spaui-topnav-menu",
                "aria-labelledby": "spaui-topnavDropdown"
              }, subData.map(function (subDataItem, subDataIndex) {
                var subItemClassName = (0, _classnames["default"])('spaui-topnav-menu-item', subDataItem.className || '');

                if (subDataItem.type === 'divider') {
                  return _react["default"].createElement("div", {
                    key: subDataIndex,
                    className: "spaui-topnav-menu-divider"
                  });
                }

                return _react["default"].createElement(LinkComponent, _extends({
                  name: subDataItem.key,
                  key: subDataIndex,
                  className: subItemClassName,
                  href: subDataItem.url || undefinedUrl,
                  target: subDataItem.target
                }, (0, _index.getSupportEventMap)(subDataItem), (0, _index.getDataSet)(subDataItem)), subDataItem.label || '');
              })));
            } else {
              result = _react["default"].createElement("li", {
                role: "presentation",
                className: liClassName,
                key: dataIndex
              }, _react["default"].createElement(LinkComponent, _extends({
                name: key,
                role: "button",
                className: itemClassName,
                href: url || undefinedUrl,
                target: target
              }, (0, _index.getSupportEventMap)(dataItem), (0, _index.getDataSet)(dataItem)), label));
            }

            return result;
          }

          if (type === 'search') {
            var _searchValue;

            var _onChange;

            if (typeof searchValue !== 'undefined') {
              _searchValue = searchValue;
            } else {
              _searchValue = dataItem.value || '';
            }

            if (typeof onSearchChange !== 'undefined') {
              _onChange = onSearchChange;
            } else {
              _onChange = dataItem.onChange || function () {};
            }

            result = _react["default"].createElement("li", {
              role: "presentation",
              className: "nav-item",
              key: dataIndex
            }, _react["default"].createElement("form", {
              className: "form-inline spaui-topnav-form spaui-topnav-right"
            }, _react["default"].createElement("input", _extends({
              className: "form-control",
              type: "text",
              value: _searchValue,
              placeholder: dataItem.placeholder,
              onChange: _onChange
            }, (0, _index.getSupportEventMap)(dataItem), (0, _index.getDataSet)(dataItem)))));
          } else if (type === 'userinfo') {
            result = _react["default"].createElement("li", {
              role: "presentation",
              className: "nav-item",
              key: dataIndex
            }, _react["default"].createElement("div", {
              className: "userinfo"
            }, _react["default"].createElement("div", {
              className: "user btn-group spaui-topnav-drop"
            }, dataItem.txUrl || dataItem.nickname || subData.length > 0 ? _react["default"].createElement("button", _extends({
              type: "button",
              className: "btn btn-link btn-sm spaui-topnav-toggle",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false"
            }, (0, _index.getSupportEventMap)(dataItem), (0, _index.getDataSet)(dataItem)), dataItem.txUrl ? _react["default"].createElement("img", {
              className: "user-avatar",
              src: dataItem.txUrl || '',
              width: "30",
              height: "30"
            }) : null, _react["default"].createElement("span", null, dataItem.nickname ? _react["default"].createElement("span", {
              className: "menu-text"
            }, dataItem.nickname || '') : null, subData.length > 0 ? _react["default"].createElement("i", {
              className: "icon-darr",
              "aria-hidden": "true"
            }) : null)) : null, subData.length > 0 ? _react["default"].createElement("div", {
              className: "spaui-topnav-menu"
            }, subData.map(function (subDataItem, subDataIndex) {
              if (!subDataItem.label) {
                return null;
              }

              return _react["default"].createElement(LinkComponent, _extends({
                name: subDataItem.key,
                className: "spaui-topnav-menu-item",
                href: subDataItem.url || undefinedUrl,
                target: subDataItem.target,
                key: subDataIndex
              }, (0, _index.getSupportEventMap)(subDataItem), (0, _index.getDataSet)(subDataItem)), subDataItem.label || '');
            })) : null)));
          }

          return result;
        }));
      }));
    }
  }]);

  return NavBarCollapse;
}(_react.PureComponent);

var _default = NavBarCollapse;
exports["default"] = _default;